import React from 'react';
import styled, { css } from 'styled-components';
import colors from '../../../constants/COLORS';

interface MarketplaceLabelContainerProps {
  active?: boolean;
}

const MarketplaceLabelContainer = styled.div<MarketplaceLabelContainerProps>`
  z-index: 1;
  position: absolute;
  height: 40px;
  justify-content: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  top: 4px;
  left: 14px;
  pointer-events: none;
  transition: all 0.2s ease-in-out;
  font-size: 16px;
  font-weight: 500;

  ${(props) =>
    props.theme.isRtl &&
    css`
      left: unset;
      right: 14px;
    `}

  ${({ active }) =>
    active &&
    css`
      top: -8px;
      font-size: 12px;

      &::after {
        width: 100%;
      }
    `}
`;

const MarketplaceLabel = styled.label`
  z-index: 2;
  position: relative;
  color: ${colors.MARKETPLACE_DARK_GREY};

  transition: color 0.2s ease-in-out;
`;

interface LabelProps {
  children?: any;
  for?: string;
  active?: boolean;
}

const Label = ({ active, ...props }: LabelProps) => (
  <MarketplaceLabelContainer active={active}>
    <MarketplaceLabel {...props} />
  </MarketplaceLabelContainer>
);
export default Label;
